import { render, staticRenderFns } from "./CreateSlug.vue?vue&type=template&id=7272e9fd&scoped=true&"
import script from "./CreateSlug.vue?vue&type=script&lang=js&"
export * from "./CreateSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272e9fd",
  null
  
)

export default component.exports